import React from "react";
import {
  Box,
  Dialog,
  Grid2 as Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DateTimeInput } from "../../../shared/ReusableComponents/DateTimeInput";
import { DateTimeFormats } from "../../../shared/utils/DateFormatter";
import { GridCloseIcon } from "@mui/x-data-grid";
import { Input, Button } from "../../../shared/ReusableComponents";
import { CommonFunctions } from "../../../shared/utils/CommonFunctions";
import { useSelector } from "react-redux";
import moment from "moment";
const style = {
  "& .MuiOutlinedInput-root": {
    "&.Mui-disabled": {
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#B1B1B1",
      },
    },
    "&:hover": {
      "&.Mui-disabled": {
        backgroundColor: "#fff", // Prevent hover background change on disabled input
        "& fieldset": {
          borderColor: "#B1B1B1", // Prevent hover border color change on disabled input
        },
      },
    },
  },
};

export const FluidOrderDialog = ({
  openDialog,
  handleClose,
  adminType,
  administerStartDate,
  setAdministerStartDate,
  administerStartTime,
  setAdministerStartTime,
  administerEndDate,
  setAdministerEndDate,
  administerEndTime,
  setAdministerEndTime,
  counterSignedBy,
  handleCounterSignedByChange,
  handleSubmit,
  errors,
  setErrors,
  selectedRow,
  adultFluidData,
}: {
  openDialog: boolean;
  handleClose: () => void;
  adminType: any;
  administerStartDate: any;
  setAdministerStartDate: any;
  administerStartTime: any;
  setAdministerStartTime: any;
  administerEndDate: any;
  setAdministerEndDate: any;
  administerEndTime: any;
  setAdministerEndTime: any;
  counterSignedBy: string;
  handleCounterSignedByChange: any;
  handleSubmit: () => void;
  errors: any;
  setErrors: any;
  selectedRow: any;
  adultFluidData: any;
}) => {
  const rowStyle = {
    backgroundColor: "#fff",
    "& > .MuiTableCell-root": {
      border: "3px solid #f5f5f5",
    },
  };
  const auth = useSelector((state: any) => state.login);
  const tableHeaders = [
    { label: "Indication", key: "indication" },
    { label: "Fluid Type", key: "fluidType" },
    { label: "Volume (mL)", key: "volume" },
    { label: "Additive and Amount", key: "additiveAndAmount" },
    { label: "Rate (mL/hr)", key: "rate" },
    { label: "Route", key: "route" },
  ];

  const effectiveDateTime = selectedRow
    ? moment.utc(selectedRow?.createdOn).local()
    : moment.utc(adultFluidData?.createdOn).local();
  const startDateAdministered = moment.utc(selectedRow?.startDate).local();
  const administerEndLocalDate = moment.utc(administerEndDate).local();

  return (
    <React.Fragment>
      <Dialog open={openDialog} onClose={handleClose} maxWidth="md">
        <Box sx={{ padding: "40px" }}>
          <IconButton
            edge="end"
            onClick={handleClose}
            aria-label="close"
            sx={{
              position: "absolute",
              right: 25,
              top: 8,
              color: "#424242",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Box sx={{ textAlign: "center", marginTop: "-10px" }}>
            <span
              className="material-symbols-outlined medicine-icon"
              style={{ fontSize: "55px" }}
            >
              vaccines
            </span>
          </Box>

          <div style={{ overflowX: "auto", marginTop: 1 }}>
            <Table
              sx={{
                mt: 2,
                borderCollapse: "separate",
                borderSpacing: 0,
                "& .MuiTableCell-root": {
                  fontSize: "0.875rem",
                  padding: "4px 8px",
                  lineHeight: 2.1,
                },
              }}
            >
              <TableHead
                sx={{
                  backgroundColor: "var(--color-default)",
                  border: "2px solid #F5F5F5",
                }}
              >
                <TableRow>
                  {tableHeaders.map((header: any) => (
                    <TableCell key={header.key}>{header.label}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={rowStyle}>
                  <TableCell>{selectedRow?.indication}</TableCell>
                  <TableCell>{selectedRow?.fluidType}</TableCell>
                  <TableCell>{selectedRow?.volume}</TableCell>
                  <TableCell>
                    {selectedRow?.additiveAmount
                      ? selectedRow?.additiveAmount
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {selectedRow?.rate ? selectedRow?.rate : "-"}
                  </TableCell>
                  <TableCell>{selectedRow?.route}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          <Box sx={{ mt: 4, ml: 5, mr: 5 }}>
            {adminType === "start" && (
              <Grid container spacing={2}>
                <Grid size={6}>
                  <DateTimeInput
                    label="Start Date"
                    type="date"
                    size="small"
                    name="administerStartDate"
                    format={DateTimeFormats.DateFormat}
                    value={administerStartDate}
                    required
                    error={errors?.administerStartDate}
                    minDate={effectiveDateTime}
                    maxDate={moment()}
                    onChange={(val) => {
                      setAdministerStartDate(val);

                      const isToday = moment().isSame(val, "day");
                      const defaultTime = isToday
                        ? moment()
                        : moment(val).startOf("day");

                      setAdministerStartTime(defaultTime); // reset time appropriately

                      if (val && moment(val, "DD/MM/YYYY", true).isValid()) {
                        setErrors((prev: any) => ({
                          ...prev,
                          administerStartDate: false,
                        }));
                      }
                    }}
                    hasError={
                      errors?.administerStartDate
                        ? !administerStartDate
                          ? "Start Date is required."
                          : "Start Date has invalid format."
                        : ""
                    }
                    classes={
                      errors?.administerStartDate
                        ? "warnStyle"
                        : "administer-date-picker"
                    }
                    // disableFuture
                    isDisabled={true}
                  />
                </Grid>
                <Grid size={6}>
                  <DateTimeInput
                    label="Start Time"
                    type="time"
                    size="small"
                    name="administerStartTime"
                    format={DateTimeFormats.TimeFormat}
                    value={administerStartTime}
                    required
                    error={errors?.administerStartTime}
                    hasError={
                      errors?.administerStartTime
                        ? !administerStartTime
                          ? "Start Time is required."
                          : "Start Time has invalid format."
                        : ""
                    }
                    onChange={(val) => {
                      setAdministerStartTime(val);
                      if (val && moment(val, "HH:mm", true).isValid()) {
                        setErrors((prev: any) => ({
                          ...prev,
                          administerStartTime: false,
                        }));
                      }
                    }}
                    timeSteps={{ minutes: 1 }}
                    classes={
                      errors?.administerStartTime
                        ? "warnStyle"
                        : "administer-date-picker"
                    }
                    minTime={
                      administerStartDate.isSame(effectiveDateTime, "day")
                        ? effectiveDateTime
                        : moment(administerStartDate).startOf("day")
                    }
                    maxTime={
                      administerStartDate.isSame(moment(), "day")
                        ? moment()
                        : moment(administerStartDate).endOf("day")
                    }
                    isDisabled={true}
                  />
                </Grid>
              </Grid>
            )}
            {adminType === "finish" && (
              <Grid container spacing={2}>
                <Grid size={6}>
                  <DateTimeInput
                    label="Finish Date"
                    type="date"
                    size="small"
                    name="administerEndDate"
                    minDate={startDateAdministered}
                    maxDate={moment()}
                    format={DateTimeFormats.DateFormat}
                    value={administerEndDate}
                    required
                    error={errors?.administerEndDate}
                    hasError={
                      errors?.administerEndDate
                        ? !administerEndDate
                          ? "End Date is required."
                          : "End Date has invalid format."
                        : ""
                    }
                    onChange={(val) => {
                      setAdministerEndDate(val);

                      const isSameStartDate = startDateAdministered.isSame(
                        val,
                        "day"
                      );
                      const isToday = moment().isSame(val, "day");

                      let defaultTime;
                      if (isToday) {
                        defaultTime = moment();
                      } else if (isSameStartDate) {
                        defaultTime = startDateAdministered;
                      } else {
                        defaultTime = moment(val).startOf("day"); // default to 00:00
                      }

                      setAdministerEndTime(defaultTime);

                      if (val && moment(val, "DD/MM/YYYY", true).isValid()) {
                        setErrors((prev: any) => ({
                          ...prev,
                          administerEndDate: false,
                        }));
                      }
                    }}
                    classes={
                      errors?.administerEndDate
                        ? "warnStyle"
                        : "administer-date-picker"
                    }
                    isDisabled={true}
                  />
                </Grid>
                <Grid size={6}>
                  <DateTimeInput
                    label="Finish Time"
                    type="time"
                    size="small"
                    name="administerEndTime"
                    format={DateTimeFormats.TimeFormat}
                    value={administerEndTime}
                    required
                    error={errors?.administerEndTime}
                    hasError={
                      errors?.administerEndTime
                        ? !administerEndTime
                          ? "End Time is required."
                          : "End Time has invalid format."
                        : ""
                    }
                    onChange={(val) => {
                      setAdministerEndTime(val);
                      if (val && moment(val, "HH:mm", true).isValid()) {
                        setErrors((prev: any) => ({
                          ...prev,
                          administerEndTime: false,
                        }));
                      }
                    }}
                    timeSteps={{ minutes: 1 }}
                    classes={
                      errors?.administerEndTime
                        ? "warnStyle"
                        : "administer-date-picker"
                    }
                    // disableFuture
                    minTime={
                      administerEndDate &&
                      moment(administerEndLocalDate).isSame(
                        startDateAdministered,
                        "day"
                      )
                        ? moment.utc(selectedRow?.startDate).local() // use full datetime as minTime
                        : moment(administerEndDate).startOf("day") // otherwise start of the selected end day
                    }
                    maxTime={
                      administerEndDate.isSame(moment(), "day")
                        ? moment()
                        : moment().endOf("day") // allows up to 23:59
                    }
                    isDisabled={true}
                  />
                </Grid>
              </Grid>
            )}

            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid size={6} sx={style}>
                <Input
                  label="Signed by (SN)"
                  fullWidth
                  name="signedBy"
                  value={CommonFunctions.formatFirstAndLastName(
                    auth?.userInfo?.userFirstName,
                    auth?.userInfo?.userLastName,
                    { suffixKey: "sn" }
                  )}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "var(--color-border-model)" },
                  }}
                  disabled
                />
              </Grid>
              <Grid size={6}>
                <Input
                  label="Counter Signed By (RN)"
                  fullWidth
                  name="counterSignedBy"
                  type="text"
                  required
                  value={counterSignedBy}
                  onChange={handleCounterSignedByChange}
                  error={errors.counterSignedBy}
                  hasError={
                    errors.counterSignedBy
                      ? "Counter Signed By (RN) is required."
                      : ""
                  }
                  classes={
                    (errors?.counterSignedBy ? "\u200B" : "") && "warningStyles"
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              columnGap: "20px",
              alignItems: "center",
              mr: 5,
              ml: 5,
            }}
          >
            <Button
              text="Cancel"
              variant="outlined"
              size="medium"
              onClick={() => handleClose()}
            />

            <Button
              text="sign"
              variant="contained"
              size="medium"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};
